import React, { useEffect, useState } from "react";
import { Down24, Remove24 } from "@bphxd/ds-core-react/lib/icons";
import SvgSearch24 from "@bphxd/ds-core-react/lib/icons/interface/Search24";
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    InputGroup,
    Input,
    InputGroupText,
} from "reactstrap";
import { Button} from "@bphxd/ds-core-react/lib/components/button/Button";
import { useWindowSize } from "@bphxd/ds-core-react";
import { Add24 } from "@bphxd/ds-core-react/lib/icons";
export default function ACSearch({
    onACSearch,
    setNoData,
    onhandleUpload
}: {
    onACSearch: (searchField: string, searchVal: string) => void;
    setNoData: React.Dispatch<React.SetStateAction<string>>;
    onhandleUpload: () => void;
}) {
    const [searchField, setSearchField] = useState<string>("Select Category");
    const [searchVal, setSearchVal] = useState<string>("");
    const { width } = useWindowSize();

    const getSearchFieldKey = (displayField: string): string => {
        const fieldMapping: { [key: string]: string } = {
            "Sold To ID (Customer Code)": "sold_to_id",
            "Sold To Name (Customer Full Name)": "sold_to_name",
        };
        return fieldMapping[displayField] || displayField.toLowerCase().replace(/ /g, "_");
    };

    const onSearchValChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchVal(e.currentTarget.value);
        setNoData("");
    };

    const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>): void => {
        if (event.key === "Enter") {
            if (searchField !== "Select Category" && searchVal !== "") {
                event.preventDefault();
                event.stopPropagation();
                validateAndSearch();
            }
        }
    };

    useEffect(() => {
        setNoData("");
        setSearchVal("");
    }, [searchField]);

    const validateAndSearch = () => {
        const searchFieldKey = getSearchFieldKey(searchField);
        let isValid = true;
        let errorMsg = "";
    
        if (searchField === "Sold To Name (Customer Full Name)") {
            // Customer Name: Only letters, spaces, '.', '-' and '''
            const nameRegex = /^[a-zA-Z\s.'-]+$/;
            if (!nameRegex.test(searchVal)) {
                isValid = false;
                errorMsg = "Customer Name: Only letters, spaces, '.', '-' and ''' are allowed";
            }
        } else if (searchField === "Sold To ID (Customer Code)") {
            // Customer Code: Only numbers
            const codeRegex = /^[0-9]+$/;
            if (!codeRegex.test(searchVal)) {
                isValid = false;
                errorMsg = "Customer Code: Only numbers are allowed";
            }
        }
    
        if (!isValid) {
            setNoData(errorMsg);
            return;
        }
    
        onACSearch(searchFieldKey, searchVal);
    };

    return (
        <>
            <div className="row"></div>

            <div className="row">
                                {/* Dropdown */}
                                <div className="col-sm-3 col-lg-3 upd-srch-drop" style={{ position: "relative", zIndex: 10, paddingRight: "30px" }}>
                    <UncontrolledDropdown size="sm" className="mb-4">
                        <DropdownToggle
                            className="w-100 sch-drpdwn-toggle-uld rounded-0 border-0 px-2 ft-size"
                            color="#fff"
                            caret
                            style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                        >
                            {searchField}
                            <Down24
                                color="#007f00 !important"
                                className="btn-icon-suffix down-arrow-color"
                            />
                        </DropdownToggle>

                        <DropdownMenu className="dropdown-menu-sm w-100 ft-size" style={{ minWidth: "280px", whiteSpace: "normal", padding: "0.5rem 0" }}>
                            <DropdownItem onClick={() => setSearchField("Sold To ID (Customer Code)")}>
                                Sold To ID (Customer Code)
                            </DropdownItem>
                            <DropdownItem onClick={() => setSearchField("Sold To Name (Customer Full Name)")}>
                                Sold To Name (Customer Full Name)
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>

                {/* Input */}
                <div className="col-sm-5 col-lg-5" style={{ paddingLeft: "30px", paddingRight: "30px" }}>
                    <InputGroup className="input-group-merge mb-4 search-input" size="sm">
                        <Input
                            className="form-control-prepended form-control-appended ft-size"
                            placeholder={
                                searchField === "Select Category"
                                    ? "Search"
                                    : searchField === "Sold To ID (Customer Code)"
                                    ? "Search With Sold To ID"
                                    : "Search With Sold To Name"
                            }
                            type="text"
                            onChange={onSearchValChange}
                            onKeyDown={onKeyDown}
                            value={searchVal}
                        />

                        <div className="input-group-prepend">
                            <InputGroupText>
                                <SvgSearch24 color="#007f00" />
                            </InputGroupText>
                        </div>

                        <div className="input-group-append">
                            <InputGroupText
                                onClick={() => {
                                    setSearchVal("");
                                    setNoData("");
                                }}
                            >
                                {searchVal !== "" && (
                                    <Remove24 style={{ cursor: "pointer" }} />
                                )}
                            </InputGroupText>
                        </div>
                    </InputGroup>
                </div>

                {/* Button */}
                <div className="col-sm-3 col-lg-3 d-flex gap-2 align-items-center" style={{ paddingLeft: "30px" }}>
                    <Button
                        rounded="pill"
                        theme="brand"
                        level="primary"
                        size="sm"
                        style={{ width: "78px" }}
                        disabled={
                            !(searchField !== "Select Category" && searchVal !== "")
                        }
                        onClick={validateAndSearch}
                        className="upd-sch-btn mb-4 ft-size"
                    >
                        Search
                    </Button>
                    <Button
    rounded="pill"
    theme="brand"
    level="primary"
    size="sm"
    className="upd-sch-btn mb-4 ft-size"
    style={{  maxWidth:"auto !important",paddingLeft:"15px", marginLeft:"30px", whiteSpace: "nowrap" }}
    onClick={onhandleUpload}
  >
    {/* <Add24 style={{ marginRight: "3px", fontStyle:"bold"}} /> */}
    Click here to upload annual certificate
  </Button>
                </div>
            </div>
        </>
    );
}